import { helpers } from '@vuelidate/validators';

// SUP-346 — vuelidate 0.7's `email` regex accepts any non-special local-part
// character, including non-ASCII (e.g. `õie@näide.ee`); @vuelidate/validators 2's own
// `email` regex is ASCII-only (`[A-z0-9!#$%&'*+/=?^_`{|}~-]+`). AC-2 requires the same
// acceptance set as today, so this copies the 0.7 regex verbatim from the installed
// `vuelidate/lib/validators/email.js` rather than re-exporting v2's own `email`. The
// parity spec (`__tests__/validators-parity.spec.js`) is the proof this must stay
// verbatim: if a future vuelidate/vuelidate-validators bump changes either regex, that
// spec is the discriminator that decides whether this file is still needed.
// eslint-disable-next-line max-len -- copied verbatim, must not be reformatted (see above).
const vuelidate07EmailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

export default {
  $validator: helpers.regex(vuelidate07EmailRegex),
  $message: 'Value is not a valid email address',
  $params: { type: 'email' },
};
